import { render, staticRenderFns } from "./OnePageContainer.vue?vue&type=template&id=4d35fa46&scoped=true"
import script from "./OnePageContainer.vue?vue&type=script&lang=js"
export * from "./OnePageContainer.vue?vue&type=script&lang=js"
import style0 from "./OnePageContainer.vue?vue&type=style&index=0&id=4d35fa46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35fa46",
  null
  
)

export default component.exports